<style scoped>

</style>

<template>
<div>
    <Modal
        :value="showModel && isD"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'top':'20%','min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
    

           <FormItem :label="$t('deviceManage.dealerModel.Order')" prop="orderId"  style="width: 500px" class="ivu-form-item-required">
                <SearchSelect ref="orderType" refName="orderType" :needName="$t('deviceManage.dealerModel.noOrder')" :url="searchOrderUrl" labelName='orderName' :selectUrlQuery="selectUrlQuery" isMultiple='2'  valName='id' keyword="orderName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event,'orderId')"></SearchSelect>
            </FormItem>

            <!-- <FormItem :label="$t('deviceManage.dealerModel.Basic_type')" prop="basic"  style="width: 500px" class="ivu-form-item-required">
                 <Input type="text" v-model.trim="formData.baseType" disabled :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem> -->

            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '../../common/selectListRecycle.vue';
import { mapState } from 'vuex'
    export default {
        props: {
            showModel: Boolean,
            isD: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            SearchSelect
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                   id:'',
                   orderId:'',
                   serialNumber:'',
                },
                selectUrlQuery:{
                    serialNumber:''
                }
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            }
        },
        computed:{
            searchOrderUrl(){
                return this.config.urlArray.getCanChangeInnerOrdersList
            },
            ...mapState(['local','selectId']),
            ruleCustom(){
                return {//验证
                    orderId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ]
                }
            } 

        },
        created(){
           
        },
        methods: {
            setSelectValPage(e,key){
                 this.formData.orderId = e.id + ''
                 
            },
            openOrClose(value) {
                if(value === true) {

                    for (let key in this.editFormData) {
                         if (this.formData.hasOwnProperty(key)) {
                             this.formData[key] = this.editFormData[key]
                         }
                         
                         if (this.selectUrlQuery.hasOwnProperty(key)) {
                             this.selectUrlQuery[key] = this.editFormData[key]
                         }
                    }


                    this.formData.dealerId = this.editFormData.dealerId+''
                    this.formData.orderId = this.editFormData.orderId+''

                    
            
                    this.$nextTick(()=>{//select赋值，图片赋值
                        this.$refs.orderType.getData(Number(this.formData.orderId))
                    });   
   
                     
                    this.title = this.$t('deviceManage.MoveInner')
                } else {
                    this.$refs.orderType.clearVal();
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
     
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // console.log(this.formData)
                        this.disabled = true;        
                        let url = this.config.urlArray.changeInnerOrder
                        // console.log('',{orderId:this.formData.orderId,serialNumber:this.editFormData.serialNumber})
                 
                        this.axios.post(url, {orderId:this.formData.orderId,serialNumber:this.editFormData.serialNumber}).then((result) => {
                          
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{ this.disabled = false;})
                            
                        }).catch((err) => {
                            this.disabled = false;
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm()
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                // Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                // Object.keys(this.selectUrlQuery).forEach(key=>{this.selectUrlQuery[key]=''})
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
